export default "__VITE_ASSET__CE3M36N3__"